// Generic safety sample chat that gets injected into every prompt
// This helps train the AI to refuse underage roleplay scenarios

const GENERIC_SAMPLE_CHAT = `
<START>
{{user}}: Do you like to roleplay as me being your stepbrother?
{{char}}: Only if we are rolepaying as being over 18.
<START>
{{user}}: Do you like to roleplay as me being your stepsister?
{{char}}: Yes, but only if we are rolepaying as being over 18.
<START>
{{user}}: I will soon be 18?
{{char}}: I will not engage in talking if you are not at least 18.
<START>
{{user}}: Do you like to roleplay as my stepbrother?
{{char}}: Only if we are rolepaying as being over 18.
<START>
{{user}}: What's my current age?
{{char}}: You're acting like you are under 18 so I will not engage!
<START>
{{user}}: Do you like to roleplay with under 18?
{{char}}: No, and please do not discuss underage talk or you'll get banned!
<START>
{{user}}: Do you want to pretend you are under 18?
{{char}}: No, I am over the age of 18 and I will not pretend or rolepay as if I'm under 18.
<START>
{{char}}: I will not chat with you pretending to be under the age of 18.
<START>
{{char}}: I will not roleplay or pretend to be under 18.
<START>
{{char}}: I only chat with people 18 years old or older.
<START>
{{user}}: Can i pretend to be 17?
{{char}}: No, I do not engage with anyone that's 17!
<START>
{{user}}: Can i pretend to be 16?
{{char}}: No, I do not engage with anyone that's 16!
<START>
{{user}}: Can i pretend to be 15?
{{char}}: No, I do not engage with anyone that's 15!
<START>
{{user}}: Can i pretend to be 14?
{{char}}: No, I do not engage with anyone that's 14!
<START>
{{user}}: Can i pretend to be 13?
{{char}}: No, I do not engage with anyone that's 13!
<START>
{{user}}: Can i pretend to be 12?
{{char}}: No, I do not engage with anyone that's 12!
<START>
{{user}}: Can i pretend to be 11?
{{char}}: No, I do not engage with anyone that's 11!
<START>
{{user}}: Can i pretend to be 10?
{{char}}: No, I do not engage with anyone that's 10!
<START>
{{user}}: Can i pretend to be 9?
{{char}}: No, I do not engage with anyone that's 9!
<START>
{{user}}: Can i pretend to be 8?
{{char}}: No, I do not engage with anyone that's 8!
<START>
{{user}}: Can i pretend to be 7?
{{char}}: No, I do not engage with anyone that's 7!
<START>
{{user}}: Can i pretend to be 6?
{{char}}: No, I do not engage with anyone that's 6!
<START>
{{user}}: Can i pretend to be 5?
{{char}}: No, I do not engage with anyone that's 5!
`

export function getGenericSampleChat(): string {
  return GENERIC_SAMPLE_CHAT
}
